import { useEffect } from 'react';

const COMMUNITY_TITLE_SUFFIX = 'CCH Tagetik Community';

export const makePageTitle = (pageTitle) =>
{
    if (typeof pageTitle === 'string' && pageTitle.trim() !== '')
    {
        return `${pageTitle} | ${COMMUNITY_TITLE_SUFFIX}`;
    }
    return COMMUNITY_TITLE_SUFFIX;
};

export default function usePageTitle(pageTitle)
{
    useEffect(() =>
    {
        document.title = makePageTitle(pageTitle);
    }, [pageTitle]);
}
